import React, { useState, useEffect } from 'react';
import { BASE_URL, instanceAxios } from "../../config";
import { toast } from "react-toastify";

import FileUploadRegister from './FileUploadControl';
export default function SettingShow(props) {
    const [pic_logofile, Setpic_logofile] = useState();
    const [pic_Bannerfile, Setpic_Bannerfile] = useState();    
    const [siteTitle, SetSiteTitle] = useState('');
    const [BannerFrist, SetBannerFrist] = useState('');
    const [FooterText, SetFooterText] = useState('');
    const [BannerSecond, SetBannerSecond] = useState('');
    const [typeShow, SettypeShow] = useState('');
    const [SenderEmail, SetSenderEmail] = useState('');
    const [SenderPassword, SetSenderPassword] = useState('');
    const [MerchantID, SetMerchantID] = useState('');

    const SaveSetting = () => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/SiteSetting.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'Insert',
                pic_logofile: pic_logofile,
                pic_Bannerfile: pic_Bannerfile,
                siteTitle: siteTitle,
                BannerFrist: BannerFrist,
                BannerSecond: BannerSecond,
                pic_Bannerfile: pic_Bannerfile,
                typeShow: typeShow,
                SenderEmail: SenderEmail,
                SenderPassword: SenderPassword,
                MerchantID: MerchantID,
                FooterText: FooterText,

            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {

                    toast.success("با موفقیت  ثبت شد");
                }
            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })

    }

    const GetListSiteSetting = () => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/SiteSetting.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'GetList'
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200 && response.data.length != 0) {
                    Setpic_logofile(response.data[0].pic_logofile);
                    SetSiteTitle(response.data[0].siteTitle);
                    SettypeShow(response.data[0].typeShow);
                    SetSenderEmail(response.data[0].SenderEmail);
                    SetSenderPassword(response.data[0].SenderPassword);
                    SetMerchantID(response.data[0].MerchantID);
                    Setpic_Bannerfile(response.data[0].pic_Bannerfile);
                    SetBannerFrist(response.data[0].BannerFrist);
                    SetBannerSecond(response.data[0].BannerSecond);
                    SetFooterText(response.data[0].FooterText)
                }
            })
            .catch((err) => {

            })

    }

    useEffect(() => {
        GetListSiteSetting();
    }, [])
    return (
        <div className="tab-content">
            <div className="col-10   " style={{ marginTop: "5px" }}>
                <div className="register-box-body" style={{ padding: "0px" }}>
                    <div className="box-body">
                        <div className="box box-success">
                            <div className="box-header" style={{ display: "-webkit-inline-box" }}>
                                <i className="icon ion-ios-settings-strong" style={{ fontSize: "25px", color: "#52ac7a" }}></i>
                                <h3 style={{ marginRight: "15px", marginTop: "6px", color: "#52ac7a" }}>تنطیمات مربوط به نمایش سایت</h3>
                            </div>
                            <div className="box-body chat" id="chat-box" >
                                <div className="form-group has-feedback">
                                    <span> عنوان سایت
                                    </span>
                                    <input type="text" className="form-control" value={siteTitle} onChange={(e) => SetSiteTitle(e.target.value)} style={{ fontSize: "14px" }} />

                                </div>
                                <span> لوگو سایت
                                </span>
                                <FileUploadRegister value={pic_logofile} onChange={e => Setpic_logofile(e)} id={"ControlRegister"} />


                                <div className="row col-10">
                                    <div className="col-3">
                                        <div className="checkbox icheck">
                                            <label style={{ marginRight: "20px" }}>
                                                <input type="radio" name="show" checked={typeShow === "tab" ? "checked" : ""} onChange={() => SettypeShow("tab")} /> نمایش تبی
                                 </label>

                                        </div>
                                    </div>

                                    <div className="col-3">
                                        <div className="checkbox icheck">

                                            <label style={{ marginRight: "20px" }} >
                                                <input type="radio" name="show" checked={typeShow === "link" ? "checked" : ""} onChange={() => SettypeShow("link")} /> نمایش لینکی
                                 </label>
                                        </div>
                                    </div>


                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <div className="register-box-body" style={{ padding: "0px" }}>
                    <div className="box-body">
                        <div className="box box-info">
                            <div className="box-header" style={{ display: "-webkit-inline-box" }}>
                                <i className="icon ion-ios-settings-strong" style={{ fontSize: "25px", color: "rgb(52, 163, 198)" }}></i>
                                <h3 style={{ marginRight: "15px", marginTop: "6px", color: "rgb(52, 163, 198)" }}>تنطیمات مربوط به بنر صفحه اصلی</h3>
                            </div>
                            <div className="box-body chat" id="chat-box" >
                                <div className="form-group has-feedback">
                                    <span> متن اول
                                    </span>
                                    <input type="text" className="form-control" value={BannerFrist} onChange={(e) => SetBannerFrist(e.target.value)} style={{ fontSize: "14px" }} />

                                </div>
                                <div className="form-group has-feedback">
                                    <span> متن دوم
                                    </span>
                                    <input type="text" className="form-control" value={BannerSecond} onChange={(e) => SetBannerSecond(e.target.value)} style={{ fontSize: "14px" }} />

                                </div>
                                <span> تصویر بنر
                                </span>
                                <FileUploadRegister value={pic_Bannerfile} onChange={e => Setpic_Bannerfile(e)} id={"ControlRegister1"} />
                            </div>

                        </div>

                    </div>

                </div>
                <div className="register-box-body" style={{ padding: "0px" }}>
                    <div className="box-body">
                        <div className="box box-info">
                            <div className="box-header" style={{ display: "-webkit-inline-box" }}>
                                <i className="icon ion-ios-settings-strong" style={{ fontSize: "25px", color: "rgb(52, 163, 198)" }}></i>
                                <h3 style={{ marginRight: "15px", marginTop: "6px", color: "rgb(52, 163, 198)" }}>تنطیمات مربوط به  فوتر صفحه صلی</h3>
                            </div>
                            <div className="box-body chat" id="chat-box" >
                                <div className="form-group has-feedback">
                                    <span> متن 
                                    </span>
                                    <input type="text" className="form-control" value={FooterText} onChange={(e) => SetFooterText(e.target.value)} style={{ fontSize: "14px" }} />

                                </div>                                
                            </div>

                        </div>

                    </div>

                </div>
                <div className="register-box-body" style={{ padding: "0px" }}>
                    <div className="box-body">
                        <div className="box box-info">
                            <div className="box-header" style={{ display: "-webkit-inline-box" }}>
                                <i className="icon ion-ios-settings-strong" style={{ fontSize: "25px", color: "rgb(52, 163, 198)" }}></i>
                                <h3 style={{ marginRight: "15px", marginTop: "6px", color: "rgb(52, 163, 198)" }}>تنطیمات مربوط به ارسال فایل</h3>
                            </div>
                            <div className="row box-body chat" id="chat-box1" >


                                <div className="form-group has-feedback col-6">
                                    <span> ایمیل فرستنده
                                 </span>
                                    <input type="text" className="form-control" value={SenderEmail} onChange={(e) => SetSenderEmail(e.target.value)} style={{ fontSize: "14px" }} />
                                </div>
                                <div className="form-group has-feedback col-6">
                                    <span> پسورد ایمیل
                                 </span>
                                    <input type="text" className="form-control" value={SenderPassword} onChange={(e) => SetSenderPassword(e.target.value)} style={{ fontSize: "14px" }} />
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
                <div className="register-box-body" style={{ padding: "0px" }}>
                    <div className="box-body">
                        <div className="box box-warning">
                            <div className="box-header" style={{ display: "-webkit-inline-box" }}>
                                <i className="icon ion-ios-settings-strong" style={{ fontSize: "25px", color: "rgb(52, 163, 198)" }}></i>
                                <h3 style={{ marginRight: "15px", marginTop: "6px", color: "rgb(52, 163, 198)" }}>تنطیمات مربوط کارت بانکی زرین پال   </h3>
                            </div>
                            <div className="row box-body chat" id="chat-box1" >
                                <div className="form-group has-feedback col-6">
                                    <span> MerchantID
                                 </span>
                                    <input type="text" className="form-control" value={MerchantID} onChange={(e) => SetMerchantID(e.target.value)} style={{ fontSize: "14px" }} />
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
                <div className="row col-12" style={{ marginTop: "10px", paddingBottom: "30px" }}>
                    <div className="col-2">
                        <button className="btn btn-primary btn-block btn-flat" style={{ fontSize: "14px" }} onClick={(e) => SaveSetting()}>ثبت</button>
                    </div>

                </div>
            </div>
        </div>

    );
} 
